<template>
    <div class="dashContent">
        <div class="panel-heading componentHeader">
            <div class="pull-left">
                <h2>{{ getTranslation('lbl_panel_headline_tickets') }}</h2>
            </div>
            <div class="pull-right">
                <div style="display: inline-block">
                    <strong>{{ getTranslation('lbl_ticket_filter') }}:</strong>
                    <div class="dropdown" v-on-clickaway="dropClose" :class="{ open: isOpened }">
                        <button class="dropdown-toggle form-control" @click.prevent="dropToggle" type="button">
                            {{ getTranslation('lbl_ticket_filter_' + filterKey) }}
                            <span class="caret"></span></a>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-right" @click="dropToggle">
                            <li><a href="#" @click.prevent="toFilter('all');">
                                {{ getTranslation('lbl_ticket_filter_all') }}
                            </a></li>
                            <li><a href="#" @click.prevent="toFilter('accepted');">
                                {{ getTranslation('lbl_ticket_filter_accepted') }}
                            </a></li>
                            <li><a href="#" @click.prevent="toFilter('pending');">
                                {{ getTranslation('lbl_ticket_filter_pending') }}
                            </a></li>
                            <li><a href="#" @click.prevent="toFilter('closed');">
                                {{ getTranslation('lbl_ticket_filter_closed') }}
                            </a></li>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <table class="table table-striped table-condensed table-bordered">
            <thead>
            <tr>
                <!--<th>{{ translations.lbl_ticket_id }}</th>-->
                <th>{{ getTranslation('lbl_ticket_create') }}</th>
                <th>{{ getTranslation('lbl_ticket_state') }}</th>
                <th>{{ getTranslation('lbl_ticket_caller') }}</th>
                <th class="action">{{ getTranslation('lbl_grid_col_action') }}</th>
            </tr>
            </thead>
            <tbody>
            <!--<tr v-for="(ticket, indx) in tickets">-->
            <tr v-for="(ticket, indx) in filtered">
                <!--<td>-->
                <!--<span>{{ ticket._id }}</span>-->
                <!--</td>-->
                <td>
                    <span>{{ formatDisplayDate(ticket.created) }}</span>
                </td>
                <td>
                    <span>{{ ticket.stateLabel }}</span>
                </td>
                <td>
                    <span>{{ ticket.caller }}</span>
                </td>
                <td style="white-space: nowrap;">
                    <button @click.prevent="audioPlay(indx)" class="btn btn-default"
                            :title="getTranslation(audioTooltip(indx))">
                        <span class="fa" :class="audioButtonClass(indx)" aria-hidden="true"></span></button>
                    <button @click.prevent="showHistory(ticket._id)" class="btn btn-primary"
                            :title="getTranslation('lbl_history')"><span
                            class="fa fa-history" aria-hidden="true"></span></button>
                    <audio :id="'audio' + indx"
                           ref="audio"
                           @ended="audioStop(indx)"
                           :src="recordingUrl + ticket._id"
                    ></audio>
                    <button v-if="ticketActive(ticket.state)" @click="closeTheTicket(ticket._id)"
                            class="btn btn-warning"><span
                            class="fa fa-window-close-o" aria-hidden="true"
                            :title="getTranslation('lbl_close_ticket')"></span></button>
                    <!--:src="recordingUrl + client.twilioAccountSid + '/Recordings/' + ticket.recordingSid"-->
                    <!--:src="recordingUrl + ticket._id"-->
                </td>
            </tr>
            </tbody>
        </table>
        <banet-modal-info @infoClose="closeModalInfo" :show="showModalInfo"
                          :showFooter="true"
                          :body="ticketHistory"
                          :title="callStatusHeader">
        </banet-modal-info>
        <banet-modal-confirm
                @confirmNo="confirm(false)"
                @confirmYes="confirm(true)"
                :show="showConfirm"
                :showFooter="true"
                :title="getTranslation('modal_confirm_title')"
                :body="getTranslation('label_confirm_ticket_close')">
        </banet-modal-confirm>
    </div>
</template>

<script>
    import {mainEventBus} from '../../../../main';
    import {translationMixin} from '../../../../Banet/mixins/translationMixin.js';
    import BanetModalInfo from '../../../../Banet/errorsAndNotifications/BanetModalInfo.vue';
    import {dropdownMixin} from '../../../../Banet/mixins/dropdownMixin.js';
    import {dateMixin} from '../../../../Banet/mixins/dateMixin.js';
    import {audioMixin} from '../../../../Banet/mixins/audioMixin';
    import {mixin as clickaway} from 'vue-clickaway';
    import BanetModalConfirm from '../../../../Banet/errorsAndNotifications/BanetModalConfirm.vue';

    export default {
        mixins: [translationMixin, dropdownMixin, clickaway, dateMixin, audioMixin],
        components: {
            banetModalInfo: BanetModalInfo,
            banetModalConfirm: BanetModalConfirm
        },
        props: ['client'],
        data: function () {
            return {
               showConfirm: false,
               callStatus: "",
                ticketGrid: Array,
                displayTicketGrid: Array,
                ticketHistory: String,
                showModalInfo: false,
                filterState: 'Pending',
                init: true,
                filterKey: 'all',
//                recordingUrl: 'https://api.twilio.com/2010-04-01/Accounts/', // twilio site
                logTicketId: '',
                audioPlayingIndex: -1,
               toCloseTicketId: ''
            }
        },
        created: function () {
            this.$socket.emit('getTickets', this.client);
        },
        computed: {
           callStatusHeader: function(){
              // not usable, as status is very short
//              let callStatus = (this.callStatus) ? this.getTranslation('lbl_call_status') + ' - ' + this.callStatus :
//                 this.getTranslation('lbl_call_no_status');
              let callStatus = this.getTranslation('lbl_ticket_log_headline');
              return callStatus;
           },
            rootPath: function(){
              return mainEventBus.$data.serverURL;
            },
            recordingUrl: function() {
              return this.rootPath + '/record/get/'
            },
            tickets: function () {
                return this.ticketGrid;
            },
            filtered: function () {
                let data = this.ticketGrid;
                if (!this.init) {
//                    if(!this.filterKey){
//                        return this.displayTicketGrid;
//                    }
                    let state = this.filterKey;
                    if (state == 'all') return data;
                    if (state && data && data.length > 0) {
                        data = data.filter(function (row) {
                            return Object.keys(row).some(function (key) {
                                return String(row[key]).toLowerCase().indexOf(state) > -1;
                            })
                        })
                    }
                } else {

                }
                return data;
            }
        },
        sockets: {
            ticketChanged: function () {
                this.$socket.emit('getTickets', this.client);
                this.$socket.emit('getLogs', this.logTicketId);
            },
            logChanged: function () {
                this.$socket.emit('getLogs', this.logTicketId);
                this.$socket.emit('getTickets', this.client);
            },
            callStatusUpdated: function(callStatus){
               this.$socket.emit('getLogs', this.logTicketId);
               this.callStatus = callStatus;
            },
            ticketList: function (data) {
                this.ticketGrid = data;
                for (let i = 0; i < this.ticketGrid.length; i++) {
                   this.audioStatus[i] = false;
                }
                this.displayTicketGrid = data;
                for (let ind in this.displayTicketGrid) {
                    this.displayTicketGrid[ind].stateLabel = this.getTranslation('lbl_ticket_state_' +
                        this.displayTicketGrid[ind].state);
                }
                if (this.init) {
                    this.toFilter('pending');
                } else {
                    this.toFilter(this.filterKey);
                }
                this.init = false;
            },
            logList: function (logs) {
                this.ticketHistory = this.buildTicketHistory(logs);
//                this.showModalInfo = true;
            },
            clientData: function (client) {
//                this.client = client;
            }
        },
        methods: {
            showHistory: function (ticketId) {
                this.logTicketId = ticketId;
                this.$socket.emit('getLogs', ticketId);
                this.showModalInfo = true;
            },
            closeModalInfo: function () {
                this.ticketHistory = '';
                this.showModalInfo = false;
            },
            buildTicketHistory: function (history) {
                let len = history.length;
                if (history.length <= 0) {
                    return ''
                }
                let text = '<ul class="history">';
                let logTable = '<table class="table table-striped">';
                for (let i = 0; i < len; i++) {
                    let ico = '';
                    switch (history[i].type) {
                        case 'pending':
                            ico = '<i class="fa fa-hourglass-start text-primary" style="margin-right: 5px;"></i>';
                            break;
                        case 'accepted':
                            ico = '<i class="fa fa-check text-success" style="margin-right: 5px;"></i>';
                            break;
                        case 'denied':
                            ico = '<i class="fa fa-hand-stop-o text-danger" style="margin-right: 5px;"></i>';
                            break;
                        case 'closed':
                            ico = '<i class="fa fa-check-square" style="margin-right: 5px;"></i>';
                            break;
                        case 'abort':
                            ico = '<i class="fa fa-ban text-danger" style="margin-right: 5px;"></i>';
                            break;
                        default:
                            ico = '<i class="fa fa-phone text-info" style="margin-right: 5px;"></i>';
                            break;
                    }
                    text += '<li>' + ico + ' ' + this.getTranslation('lbl_ticket_state_' + history[i].type) + '<ul class="history">';
                    text += '<li>' + this.formatDisplayDate(history[i].date) + '</li>';
                    text += '<li>' + history[i].value + '</li>';
                    text += '</ul></li>';
                   logTable += '<tr>';
                   logTable += '<td>' + ico + ' ' + this.getTranslation('lbl_ticket_state_' + history[i].type) + '</td>';
                   // statuses: queued, initiated, ringing, in-progress, busy, failed, no-answer, canceled, completed,
                   logTable += '<td>' + ((history[i].callStatus) ? this.getTranslation('lbl_ticket_state_' +
                         history[i].callStatus) : this.getTranslation('lbl_ticket_state_missing')) + '</td>';
                   logTable += '<td>' + this.formatDisplayDate(history[i].date) + '</td>';
                   logTable += '<td>' + history[i].value + '</td>';
                   logTable += '</tr>';
                }
                text += '</ul>';
               logTable += '</table>';
//                return text;
                return logTable;
            },
            toFilter: function (key) {
                this.filterKey = key;
                let lbl = key ? key.charAt(0).toUpperCase() + key.slice(1) : 'All';
                this.filterState = lbl;
            },
            closeTheTicket(ticketId){
                this.toCloseTicketId = ticketId;
                this.showConfirm = true;
            },
            ticketActive(state){
               switch (state) {
                  case 'closed':
                  case 'accepted':
                     return false;
                     break;
                  case 'pending':
                  case 'call':
                  case 'denied':
                  default:
                     break;
               }
               return true;
            },
           confirm: function(y){
              this.showConfirm = false;
              let ticketId = this.toCloseTicketId;
              this.toCloseTicketId = '';
              if(y){
                 this.$socket.emit('closeTicket', ticketId);
                  this.$http.post('refresh').then(res=>{
                      console.log('REFRESH');
                  });
              } else {
                 return false;
              }
           }
        }
    }
</script>

<style>
    .borderless th {
        border: none;
    }
    ul.history {
        list-style: none;
    }

    ul.history li {
        margin-left: -15px;
    }
</style>


// WEBPACK FOOTER //
// Tickets.vue?54bf8719